{
  "AID_EL_KEBIR": "Aïd el-Kébir",
  "ALLEGE_EN_MATIERES_GRASSES_MG": "Allégé en matières grasses",
  "ALLEGE_EN_SUCRE": "Allégé en sucre",
  "ALLEMAGNE": "Allemagne",
  "ANNIVERSAIRE_DE_MAGASIN": "Anniversaire de magasin",
  "ANTI_GASPI": "Anti gaspi",
  "APERITIF": "Apéritif",
  "ARTISANAL": "Artisanal",
  "ARTISANAT_SOLIDAIRE": "Artisanat solidaire",
  "BARBECUE_GRILLADES": "Barbecue grillades",
  "BAS_CARBONE_NEUTRE_EN_CARBONE": "Bas carbone / neutre en carbone",
  "BEAUJOLAIS_NOUVEAU": "Beaujolais nouveau",
  "BIEN_ETRE_ANIMAL": "Bien-être animal",
  "BLACK_FRIDAY_CYBER_MONDAY": "Black Friday / Cyber Monday",
  "BRESIL_AMERIQUE_DU_SUD_CARAIBES": "Brésil / Amérique du Sud / Caraïbes",
  "BRUNCH": "Brunch",
  "CAMEROUN": "Cameroun",
  "CARNAVAL": "Carnaval",
  "CHANDELEUR": "Chandeleur",
  "CHINE": "Chine",
  "CIRCUIT_COURT": "Circuit court",
  "COMMERCE_EQUITABLE": "Commerce équitable",
  "CONGO_RDC": "Congo / RDC",
  "CONSIGNE": "Consigne",
  "COREE": "Corée",
  "COTE_D_IVOIRE": "Côte d'Ivoire",
  "COUPE_DU_MONDE_JO": "Coupe du monde / JO",
  "DEBUT_DES_SAISONS_PRINTEMPS_ETE_ETC": "Début des saisons (printemps, été, etc.)",
  "DESSERT": "Dessert",
  "DE_SAISON": "De saison",
  "DINER": "Dîner",
  "DURABLE": "Durable",
  "ECONOMIE_CIRCULAIRE": "Économie circulaire",
  "EMBALLAGE_RECYCLABLE": "Emballage recyclable",
  "ENRICHI_EN_VITAMINES": "Enrichi en vitamines",
  "EPIPHANIE": "Épiphanie",
  "ESPAGNE": "Espagne",
  "ETATS_UNIS": "États-Unis",
  "ETHIOPIE": "Éthiopie",
  "ETRENNES": "Étrennes",
  "FAIBLE_EN_CALORIES": "Faible en calories",
  "FAIBLE_EN_FODMAPS": "Faible en FODMAPs",
  "FAIBLE_EN_GRAISSES_SATUREES": "Faible en graisses saturées",
  "FERMIER": "Fermier",
  "FETE_DES_GRANDS_MERES": "Fête des grands-mères",
  "FETE_DES_MERES": "Fête des mères",
  "FETE_DES_PERES": "Fête des pères",
  "FETE_DES_VOISINS": "Fête des voisins",
  "FETE_DE_LA_MUSIQUE": "Fête de la musique",
  "FETE_DU_TRAVAIL_1ER_MAI": "Fête du travail (1er mai)",
  "FETE_NATIONALE_14_JUILLET": "Fête nationale (14 juillet)",
  "FIN_DES_VENDANGES": "Fin des vendanges",
  "FLEXITARIEN": "Flexitarien",
  "FOIRE_AUX_VINS": "Foire aux vins",
  "FRANCE_REGIONAL": "France régional",
  "GOUTER": "Goûter",
  "GRECE": "Grèce",
  "HALAL": "Halal",
  "HALLOWEEN": "Halloween",
  "HANOUCCA": "Hanoucca",
  "HYDRATATION": "Hydratation",
  "INDE": "Inde",
  "INSTALLATION_DES_ETUDIANTS": "Installation des étudiants",
  "IRLANDE": "Irlande",
  "ITALIE": "Italie",
  "JAPON": "Japon",
  "JOURNEE_DE_LA_FEMME": "Journée de la femme",
  "JOURNEE_DE_L_ENVIRONNEMENT": "Journée de l'environnement",
  "JOURNEE_MONDIALE_SANS_PRODUIT": "Journée mondiale sans produit",
  "KASHER_CACHER": "Kasher / cacher",
  "KENYA": "Kenya",
  "KETO_FRIENDLY_CETOGENE": "Kéto-friendly / cétogène",
  "MADAGASCAR": "Madagascar",
  "MAGHREB_MAROC_ALGERIE_TUNISIE": "Maghreb (Maroc, Algérie, Tunisie)",
  "MARDI_GRAS": "Mardi gras",
  "MAROC": "Maroc",
  "MEXIQUE": "Mexique",
  "NOEL": "Noël",
  "NOUVEL_AN_CHINOIS": "Nouvel an chinois",
  "NOUVEL_AN_SAINT_SYLVESTRE": "Nouvel an / Saint-Sylvestre",
  "OKTOBERFEST": "Oktoberfest",
  "ORIGINE_FRANCE_GARANTIE": "Origine France garantie",
  "OUVERTURE_DE_LA_CHASSE": "Ouverture de la chasse",
  "OUVERTURE_DE_LA_PECHE": "Ouverture de la pêche",
  "PACKAGING_COMPOSTABLE": "Packaging compostable",
  "PALEO": "Paléo",
  "PAQUES": "Pâques",
  "PESSAH": "Pessah",
  "PETIT_DEJEUNER": "Petit déjeuner",
  "PIQUE_NIQUE": "Pique-nique",
  "PLANT_BASED": "Plant-based",
  "POISSON_D_AVRIL": "Poisson d'avril",
  "PORTUGAL": "Portugal",
  "RAMADAN": "Ramadan",
  "RENTREE_CLUBS_SPORTIFS": "Rentrée clubs sportifs",
  "RENTREE_SCOLAIRE": "Rentrée scolaire",
  "RESPONSABLE": "Responsable",
  "RICHE_EN_FIBRES": "Riche en fibres",
  "RICHE_EN_PROTEINES": "Riche en protéines",
  "ROLLAND_GARROS": "Roland-Garros",
  "ROYAUME_UNI": "Royaume-Uni",
  "SAINT_PATRICK": "Saint-Patrick",
  "SAINT_VALENTIN": "Saint-Valentin",
  "SAISON_DES_RACLETTES_FONDUES": "Saison des raclettes / fondues",
  "SANS_ARACHIDE": "Sans arachide",
  "SANS_COLORANT": "Sans colorant",
  "SANS_CONSERVATEUR": "Sans conservateur",
  "SANS_FRUITS_A_COQUE": "Sans fruits a coque",
  "SANS_GLUTEN": "Sans gluten",
  "SANS_HUILE_DE_PALME": "Sans huile de palme",
  "SANS_LACTOSE": "Sans lactose",
  "SANS_OGM": "Sans OGM",
  "SANS_PLASTIQUE": "Sans plastique",
  "SANS_SEL_AJOUTE": "Sans sel ajouté",
  "SANS_SESAME": "Sans sésame",
  "SANS_SOJA": "Sans soja",
  "SANS_SUCRE_AJOUTE": "Sans sucre ajouté",
  "SANS_UF": "Sans œuf",
  "SENEGAL": "Sénégal",
  "SNACK": "Snack",
  "SOLDES_D_HIVER_D_ETE": "Soldes d'hiver / d'été",
  "SPORT": "Sport",
  "THAILANDE": "Thaïlande",
  "TOUR_DE_FRANCE": "Tour de France",
  "TRACABILITE": "Traçabilité",
  "TRADITIONNEL": "Traditionnel",
  "TURQUIE_MOYEN_ORIENT": "Turquie / Moyen-Orient",
  "VACANCES_SCOLAIRES_INFLUENCE_ACHAT": "Vacances scolaires",
  "VEGANE_VEGAN": "Végane / vegan",
  "VEGETAL_MEDITERRANEEN": "Végétal méditerranéen",
  "VEGETARIEN": "Végétarien",
  "VENDANGES": "Vendanges",
  "VIETNAM": "Vietnam",
  "ZERO_DECHET": "Zéro déchet",
  "ZERO_SUCRE_SANS_SUCRES": "Zéro sucre / sans sucres"
}
